import BairesDevFooter from './BairesDevFooter';

export default BairesDevFooter;
